import { render, staticRenderFns } from "./LiaSidebar.vue?vue&type=template&id=38568731&scoped=true&"
import script from "./LiaSidebar.vue?vue&type=script&lang=js&"
export * from "./LiaSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LiaSidebar.vue?vue&type=style&index=0&id=38568731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38568731",
  null
  
)

export default component.exports